import React from 'react';

import '../styles/Footer.css';

const Footer = () => {
    return (
      <footer className="footer">
        <div className="container">
          <p className="text-muted footer-text">
            ©2018 San Joaquin Delta College
          </p>
        </div>
      </footer>
    );
};

export default Footer;